/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowAutofitWidth = createReactComponent(
  "arrow-autofit-width",
  "IconArrowAutofitWidth",
  [
    ["path", { d: "M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6", key: "svg-0" }],
    ["path", { d: "M10 18h-7", key: "svg-1" }],
    ["path", { d: "M21 18h-7", key: "svg-2" }],
    ["path", { d: "M6 15l-3 3l3 3", key: "svg-3" }],
    ["path", { d: "M18 15l3 3l-3 3", key: "svg-4" }]
  ]
);

export { IconArrowAutofitWidth as default };
//# sourceMappingURL=IconArrowAutofitWidth.js.map
